'use client';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import DropBoxSearch from '@/app/eflayout/Header/DropBox/DropBoxSearch';

export default function SearchV1List({ prefixCls }: { prefixCls: string }) {
    useEffect(() => {
        if (!sessionStorage.getItem('ef_search_ai_session_id')) {
            sessionStorage.setItem('ef_search_ai_session_id', uuidv4());
        }
    }, []);
    return (
        <>
            <div className={`${prefixCls}-search`}>
                <DropBoxSearch />
            </div>
        </>
    );
}
